export enum ChartYAxis {
  left,
  right
}
